import React from 'react';
import PropTypes from 'prop-types';
import SelectPanel from '../select-panel';

export default function TicketsPanels(props) {
    return (
        <div className="tb-form__list">
            {props.ticketsList.map((ticket) => (
                <SelectPanel
                    dictionary={props.dictionary}
                    key={ticket.id}
                    product={ticket}
                    productGroupsList={props.productGroupsList}
                    onApplyProductsQuantity={props.onApplyProductsQuantity}
                    quantityModifier={props.quantityModifier}
                />
            ))}
        </div>
    );
}

TicketsPanels.defaultProps = {
    ticketsList: [],
    productGroupsList: []
};

TicketsPanels.propTypes = {
    dictionary: PropTypes.object.isRequired,
    ticketsList: PropTypes.array,
    productGroupsList: PropTypes.array,
    onApplyProductsQuantity: PropTypes.func.isRequired,
};
